import { type FDealType, type FOfferType, isResidential } from '@/packages/JsonQuery';

import { type IOfferType } from '../../types';

import { getCommercialOfferTypeList } from './commercial';
import { getResidentialOfferTypeList } from './residential';

interface IParameters {
  dealType: FDealType;
  offerType: FOfferType;
  isSearchFlatShareEnabled: boolean;
  isHotelsEnabled: boolean;
}

export function getOfferTypeList(parameters: IParameters): IOfferType[][] {
  if (isResidential(parameters.offerType)) {
    return getResidentialOfferTypeList(parameters);
  } else {
    return getCommercialOfferTypeList(parameters);
  }
}
